export const RADIANCE_COSA_PRODUCTS = {
  COSA_TER: {
    name: "Cosae Ter",
    phone: {
      display: "03 80 28 29 05",
      tel: "+33380282905",
    },
  },
  AURA_TER: {
    name: "Aura Ter",
    phone: {
      display: "03 80 28 25 52",
      tel: "+33380282552",
    },
  },
};

export const getRadianceCosaProduct = (isAuraTer = false) =>
  isAuraTer ? RADIANCE_COSA_PRODUCTS.AURA_TER : RADIANCE_COSA_PRODUCTS.COSA_TER;

export const getRadianceCosaPhone = (isAuraTer = false) =>
  getRadianceCosaProduct(isAuraTer).phone;
